import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgElatedEmojiSecondary from './svgs/ElatedEmojiSecondary.js';
import SvgElatedEmoji from './svgs/ElatedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var elatedEmoji = (props => useIcon(SvgElatedEmoji, SvgElatedEmojiSecondary, props));

export { elatedEmoji as default };
